export function SignalLegend() {
  return (
    <div className="signal-legend" aria-label="First-seen age legend">
      <span>First seen</span>
      <span><i className="legend-hot" />0–24h</span>
      <span><i className="legend-fresh" />24–72h</span>
      <span><i className="legend-fading" />72h–30d</span>
    </div>
  );
}
